<template>
  <div class="tutorial-item-step-bd tutorial-info clear">
    <el-form :model="form" ref="form" class="form-section" label-position="top">
      <div class="tutorial-info">
        <el-form-item :label="$t('training_tutorial_step_info.yu_zhong')" prop="langCode" :rules="rules.langCode">
          <custom-select code="language_type" v-model="form.langCode" :placeholder="$t('Common.com_please_select')" disabled="disabled" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('training_tutorial_step_info.chan_pin_xing_hao')" prop="productCode" :rules="rules.productCode">
          <!-- <el-input
              v-model="form.productCode"
              :disabled="Boolean(productId)"
              :placeholder="
                $t('placeholder_product_code')
              "
            ></el-input> -->
          <custom-select
            url="productCodeSelectList"
            v-model="form.productCode"
            :placeholder="$t('training_tutorial_step_info.qsrcpxh')"
            :props="{ label: 'productName', value: 'productCode' }"
            :disabled="isPreview"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('training_tutorial_step_info.chan_pin_ming_cheng')" prop="productName" :rules="rules.productName">
          <el-input v-model="form.productName" :placeholder="$t('training_tutorial_step_info.qsrcpmc')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('training_tutorial_step_info.pin_pai')" prop="productBrand" :rules="rules.productBrand">
          <custom-select code="iot_product_brand" v-model="form.productBrand" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('training_tutorial_step_info.shun_xu')" prop="showOrder" :rules="rules.showOrder">
          <el-input type="number" :min="0" v-model.number="form.showOrder" :placeholder="$t('training_tutorial_step_info.qing_shu_ru_shun_xu')" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('training_tutorial_step_info.chan_pin_lian_jie')" prop="productThirdLink" :rules="rules.productThirdLink">
          <el-input v-model="form.productThirdLink" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item prop="productDesc" :rules="rules.productDesc" :label="$t('training_tutorial_step_info.xing_hao_miao_shu')">
          <el-input type="textarea" v-model="form.productDesc" :placeholder="$t('training_tutorial_step_info.qsrxhms')"></el-input>
        </el-form-item>
      </div>
      <div class="line"></div>
      <div class="tutorial-r">
        <div class="tutorial-img">
          <el-form-item prop="tutorialImage" :rules="form.productThirdLink ? [] : rules.tutorialImage" :label="$t('training_tutorial_step_info.xhfmt')">
            <t-upload :limit="1" :bizId="productId" bizType="tms.home.slide" ref="tmsHomeSlide" v-model="productList" :autoUpload="false" @effect="changeUploadRules"></t-upload>
          </el-form-item>
        </div>
        <div class="tutorial-doc">
          <!-- :rules="rules.tutorialFile" -->
          <el-form-item prop="tutorialFile" :label="$t('training_tutorial_step_info.xhjssp')">
            <t-upload
              :limit="1"
              type="file"
              :bizId="productId"
              bizType="tms.home.video"
              ref="tmsHomeVideo"
              v-model="fileList"
              :autoUpload="false"
              @effect="changeUploadRules"
              :tip="$t('training_tutorial_step_info.wjbncg500M')"
              accept=".mp4,.qlv,.qsv,.ogg,.flv,.avi,.wmv,.rmvb"
            ></t-upload>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onStep">{{ $t('training_tutorial_step_info.xybcpznsp') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';

export default {
  props: {
    productId: [String, Number],
  },
  components: {
    tUpload,
  },
  data() {
    return {
      data: {},
      form: {
        langCode: 'CN',
        productAtlas: '', // 产品图视频集，附件Id拼接字符串
        productBrand: '', // 产品品牌，1-ICE，2-SBR
        productCode: '', // 产品编码
        productDesc: '', // 产品描述
        productId: '', // 产品id(编辑时不为空！)
        productName: '', // 产品名称
        productState: '', // 状态，1-启用，0-停用
        productVedio: '', // 产品主视频，附件 Id
        productThirdLink: '',
        // 顺序
        showOrder: 0,
        // 用于上传rules验证
        tutorialImage: '',
        tutorialFile: '',
        // 文件上传
        attachList: [],
      },
      productList: [],
      fileList: [],
    };
  },
  mounted: function () {
    setTimeout(() => {
      const tips = {
        langCode: this.$t('training_tutorial_step_info.qing_xuan_ze_yu_yan'),
        productCode: this.$t('training_tutorial_step_info.btxcdzc20gzf'),
        productName: this.$t('training_tutorial_step_info.btxcdzc50gzf'),
        productBrand: this.$t('training_tutorial_step_info.qxzcppp'),
        productDesc: this.$t('training_tutorial_step_info.cdzc200gzf'),
        showOrder: this.$t('training_tutorial_step_info.xspxbnxy0'),
        tutorialImage: this.$t('training_tutorial_step_info.qsccpxhfmt'),
        tutorialFile: this.$t('training_tutorial_step_info.qsccpspwj'),
      };
      Object.keys(tips).forEach((key) => {
        this.rules[key].message = tips[key];
      });
      this.getProductDetail();
    }, 100);

    this.form.langCode = this.getJump('langCode');
  },

  computed: {
    rules() {
      return {
        langCode: { type: 'string', required: true, message: this.$t('Common.com_required') },
        productCode: [
          { required: true, message: this.$t('Common.com_required') },
          {
            type: 'string',
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20]),
          },
        ],
        productName: [
          { required: true, message: this.$t('Common.com_required') },
          {
            type: 'string',
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
        productBrand: { type: 'string', required: true, message: this.$t('Common.com_required') },
        productDesc: { type: 'string', max: 200, message: this.$t('Common.com_rules_length_max', [200]) },
        // 顺序
        showOrder: { type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        tutorialImage: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required'),
        },
        tutorialFile: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    // 获取产品详情
    getProductDetail: function () {
      if (this.productId) {
        this.$getJSON(apis.tmsProductInfo, {
          productId: this.productId,
        }).then((res) => {
          this.form = res.data;
          this.form.productBrand = `${this.form.productBrand}`;
          // 上传验证规则
          this.form.tutorialImage = this.productList.length > 0 ? 'tutorialImage' : '';
          this.form.tutorialFile = this.fileList.length > 0 ? 'tutorialFile' : '';
          this.clearValidate();
          this.$emit('update', {
            productId: this.productId,
            productCode: this.form.productCode,
            langCode: this.form.langCode,
          });
        });
      }
    },
    changeUploadRules: function () {
      this.form.tutorialImage = this.productList.length > 0 ? 'tutorialImage' : '';
      this.form.tutorialFile = this.fileList.length > 0 ? 'tutorialFile' : '';
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    // 下一步
    onStep: async function () {
      // await this.$refs.tmsHomeSlide.submit();
      // await this.$refs.tmsHomeVideo.submit();
      await Promise.all([this.$refs.tmsHomeSlide.submit(), this.$refs.tmsHomeVideo.submit()]);
      this.$refs.form.validate((val) => {
        if (val) {
          // 图片转换
          this.form.productAtlas = this.productList[0] ? this.productList[0].attachPath : '';
          this.form.productVedio = this.fileList[0] ? this.fileList[0].attachPath : '';
          this.form.attachList = this.productList.concat(this.fileList);
          if (this.productId) {
            this.$postJSON(apis.tmsProductUpdate, this.form).then(() => {
              this.$emit('step', {
                name: 'info',
                productId: this.form.productId,
                productCode: this.form.productCode,
                langCode: this.form.langCode,
              });
            });
          } else {
            this.$postJSON(apis.tmsProductAdd, this.form).then((res) => {
              this.$emit('step', {
                name: 'info',
                productId: res.data,
                productCode: this.form.productCode,
                langCode: this.form.langCode,
              });
            });
          }
        }
      });
    },
    clearValidate() {
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.tutorial-info {
  padding-bottom: 60px;
  overflow: hidden;

  .tutorial-info {
    float: left;
    width: 420px;

    .form-section {
      .el-form-item__label {
        color: #495057 !important;
        font-weight: bold;
        width: 100%;
        text-align: left;
        // margin-left: -6px;
      }

      .el-textarea__inner {
        height: 63px !important;
      }
    }

    .copy {
      float: right;
    }
  }

  .line {
    position: absolute;
    width: 1px;
    top: 24px;
    bottom: 84px;
    left: 689px;
    margin: auto;
    background: #f2f3fb;
  }

  .tutorial-r {
    float: left;
    margin-left: 49px;
    width: 355px;

    .title {
      line-height: 28px;
      color: #495057;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .tutorial-doc {
    margin-top: 24px;
  }
}
</style>
